import * as React from "react"

export const useWatchSize = <T extends HTMLElement>() => {
  const [node, setNode] = React.useState<T | null>(null)
  const [size, setSize] = React.useState<{ width: number; height: number } | null>(null)

  const resizeCallback = React.useCallback((entries: ResizeObserverEntry[]) => {
    const entry = entries[0]
    const rect = entry.target.getBoundingClientRect()
    setSize({
      width: rect.width,
      height: rect.height,
    })
  }, [])

  const ref = React.useCallback((nodeEle: T | null) => {
    setNode(nodeEle)
  }, [])

  React.useEffect(() => {
    if (!node) {
      return
    }
    const resizeObserver = new ResizeObserver(resizeCallback)
    resizeObserver.observe(node)

    return () => {
      resizeObserver.disconnect()
    }
  }, [node])

  return { ref, size }
}
